<template>
    <div class="content-review">
        <div class="wrap-title">
            <div class="title">Detail Nasabah</div>
            <button type="button" class="btn btn-scondary" v-b-modal.modal-download>Unduh Berkas</button>
            <!-- <b-dropdown class="download" id="dropdownMenuButton" right text="Unduh berkas" v-if="dataPribadi.status == 3">
        <b-dropdown-item @click="(selectedDownload = 1), $bvModal.show('modal-download')">Pernyataan Nasabah</b-dropdown-item>
        <b-dropdown-item @click="(selectedDownload = 2), $bvModal.show('modal-download')">Simulasi Transaksi</b-dropdown-item>
      </b-dropdown> -->
        </div>
        <b-modal id="modal-download" size="lg" hide-footer>
            <template #modal-title>
                <div class="wrap-download" @click="downloadViaWindow">
                    <h5 class="modal-title" id="exampleModalLabel" v-show="isLoading == false">
                        Download File
                    </h5>
                    <Loading class="loader" v-show="isLoading" />
                </div>
            </template>
            <div class="d-block" id="printCimb" ref="docPdf">
                <profil-user
                    :dataPribadi="dataPribadi"
                    :dataEmergency="dataEmergency"
                    :dataWork="dataWork"
                    :dataFinance="dataFinance"
                    :dataCustomer="dataCustomer"
                    class="profil"
                ></profil-user>
                <BoFinance ref="foo" id="printPernyataan" :dataPrint="print" class="statement" />
                <profil-perusahaan class="company-profil" :statementProfil="print.has_set_company_profile" :dataPrint="print"></profil-perusahaan>
                <Simulasi ref="simulasi" class="simulation" id="printSimulasi" :dataPrint="print" :statementSimulation="print.has_set_trading_simulation" />
                <disclosure-statement :disclosureValue="print.has_set_disclosure" :dataPrint="print"></disclosure-statement>
                <resiko :dataPrint="print" :statementRisk="print.has_set_risk"></resiko>
                <amanah :dataPrint="print" :statement="print.has_set_mandate" :disputeValue="disputeValue"></amanah>
                <div v-for="(platform, i) in dataPribadi.platform" :key="i">
                    <trading-gofx id="metraTrader" ref="gofx" :dataPrint="print" v-show="platform.code == 'BEI05002'" />
                    <trading-jfx v-show="platform.code == 'BEI05001'" id="javetnow" :dataPrint="print" />
                </div>
                <kode-akses :dataPrint="print" />
            </div>
        </b-modal>
        <div class="container">
            <div class="wrap-personal-data">
                <div class="img">
                    <div class="img-preview" v-b-modal.modal-xl>
                        <img :src="imgagePreview" alt="" v-show="changevideo == 0" />
                        <video controls v-show="changevideo == 1" id="video" :src="dataImags.video_statement">
                            <!-- <source :src="dataImags.video_statement" type="video/mp4" /> -->
                        </video>
                        <div class="text-img">
                            {{ textImage }}
                        </div>
                    </div>
                    <b-modal id="modal-xl" size="xl" hide-footer>
                        <div>
                            <Slider :attachment="dataImags" />
                        </div>
                    </b-modal>
                    <div class="wrap-img-mini">
                        <div class="img-mini">
                            <img :src="dataImags.photo" class="d-block w-100" alt="..." @click="getImg(dataImags.photo, 'Foto Terkini')" />
                        </div>
                        <div class="img-mini">
                            <img :src="dataImags.ktp" class="d-block w-100" alt="..." @click="getImg(dataImags.ktp, 'Foto KTP')" />
                        </div>
                        <div class="img-mini">
                            <img :src="dataImags.photo_ktp" class="d-block w-100" alt="..." @click="getImg(dataImags.photo_ktp, 'Foto Diri dengan KTP')" />
                        </div>
                        <div class="img-mini">
                            <img :src="dataImags.npwp" class="d-block w-100" alt="..." @click="getImg(dataImags.npwp, 'Foto NPWP')" />
                        </div>
                        <div class="img-mini">
                            <img :src="dataImags.kk" class="d-block w-100" alt="..." @click="getImg(dataImags.kk, 'Kartu Keluarga')" />
                        </div>
                        <div class="img-mini">
                            <img :src="dataImags.signature" class="d-block w-100" alt="..." @click="getImg(dataImags.signature, 'Tanda Tangan')" />
                        </div>
                        <div class="img-mini">
                            <div @click="videoURL('Video Pernyataan')" class="background-video"></div>
                        </div>
                    </div>
                </div>
                <div class="data-pribadi">
                    <div class="form-group">
                        <label for="">Nama Lengkap <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.fullname }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Tempat/ tanggal lahir <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.place_of_birth }}, {{ dataPribadi.date_of_birth | formatDate }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">No Identitas <span> * </span></label>
                        <span>:</span>
                        <span>( KTP ) {{ dataPribadi.ktp_no }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">NPWP <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.npwp_no }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Alamat sesuai KTP <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.address : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">Provinsi <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.province : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">Kota <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.regency : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">Kecamatan <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.district : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">Kelurahan <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.village : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">RT/RW <span> * </span></label>
                        <span>:</span>
                        <span
                            >{{ dataPribadi.identity_address ? dataPribadi.identity_address.neighborhood_no : "" }} /
                            {{ dataPribadi.identity_address ? dataPribadi.identity_address.citizen_no : "" }}</span
                        >
                    </div>
                    <div class="form-group">
                        <label class="detail-alamat">Kodepos <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.postcode : "" }}</span>
                    </div>

                    <div class="form-group">
                        <label for="">No Telepon Rumah <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.telephone : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Jenis Kelamin <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.gender_type ? dataPribadi.gender_type.name : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Setatus Perkawinan <span> * </span></label>
                        <span>:</span>
                        <span>{{ dataPribadi.marriage_type ? dataPribadi.marriage_type.name : "" }}</span>
                    </div>
                    <div class="form-group" v-show="dataPribadi.marriage_type.name == 'Menikah'">
                        <label for="">Nama suami/istri</label>
                        <span>:</span>
                        <span>{{ dataPribadi.partners_name }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Nama ibu kandung</label>
                        <span>:</span>
                        <span>{{ dataPribadi.mothers_name }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Status Kepemilikan Rumah</label>
                        <span>:</span>
                        <span>{{ dataPribadi.identity_address.ownership_status }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Tujuan Pembukaan Rekening</label>
                        <span>:</span>
                        <span>{{ dataPribadi.purpose_open_account_type ? dataPribadi.purpose_open_account_type.name : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Pengalaman Investasi</label>
                        <span>:</span>
                        <span>{{ dataPribadi.has_investment_experience ? "Pernah" : "Tidak" }}</span>
                    </div>
                </div>
            </div>
            <div v-b-toggle.multiCollapseExample2>
                <p class="sub-sub-title">Data Pekerjaan <span class="arrow-down pull-right" /></p>
            </div>
            <b-collapse id="multiCollapseExample2">
                <div class="form-group">
                    <label for="">Pekerjaan<span> * </span></label>
                    <span>:</span>
                    <span v-if="dataWork.other_occupation">{{ dataWork.other_occupation }}</span>
                    <span v-else>{{ dataWork.occupation_type ? dataWork.occupation_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Nama perusahaan<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataWork.company_name }}</span>
                </div>
                <div class="form-group">
                    <label for="">Alamat Perusahaan<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataWork.company_address ? dataWork.company_address.address : "" }}</span>
                </div>
                <div class="form-group">
                    <label>Kodepos<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataWork.company_address ? dataWork.company_address.postcode : "" }}</span>
                </div>
                <div class="form-group">
                    <label>No Telepon perusahaan<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataWork.company_address ? dataWork.company_address.telephone : "" }}</span>
                </div>
                <div class="form-group">
                    <label>No faksimail perusahaan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address ? dataWork.company_address.fax : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Bidang usaha<span> * </span></label>
                    <span>:</span>
                    <span v-if="dataWork.other_position">{{ dataWork.other_position }}</span>
                    <span v-else>{{ dataWork.industrial_type ? dataWork.industrial_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Jabatan<span> * </span></label>
                    <span>:</span>
                    <span v-if="dataWork.business_sector">{{ dataWork.business_sector }}</span>
                    <span v-else>{{ dataWork.position_type ? dataWork.position_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Lama pekerjaan</label>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Saat ini<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataWork.work_year }}</span>
                    <span class="tahun">Tahun</span>
                    <span>{{ dataWork.work_month }}</span>
                    <span class="tahun">Bulan</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Perusahaan sebelumnya</label>
                    <span>:</span>
                    <span>{{ dataWork.work_year_previous }}</span>
                    <span class="tahun">Tahun</span>
                </div>
            </b-collapse>

            <div class="" v-b-toggle.dataKeuangan>
                <p class="sub-sub-title">Data Keuangan dan transaksi <span class="arrow-down pull-right" /></p>
            </div>
            <b-collapse id="dataKeuangan">
                <div class="form-group">
                    <label for="">Penghasilan<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataFinance.salary_type ? dataFinance.salary_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Lokasi rumah</label>
                    <span>:</span>
                    <span>{{ dataFinance.wealth_list.home_location }}</span>
                </div>
                <div class="form-group">
                    <label for="">Nilai NJOP</label>
                    <span>:</span>
                    <span>{{ dataFinance.wealth_list.njop_value }}</span>
                </div>
                <div class="form-group">
                    <label for="">Deposit Bank</label>
                    <span>:</span>
                    <span>{{ dataFinance.wealth_list.deposit }}</span>
                </div>
                <div class="form-group">
                    <label for="">Jumlah</label>
                    <span>:</span>
                    <span>{{ dataFinance.wealth_list.total_deposit }}</span>
                </div>
                <div class="form-group">
                    <label for="">Lainnya</label>
                    <span>:</span>
                    <span>{{ dataFinance.wealth_list.other }}</span>
                </div>
            </b-collapse>

            <div class="" v-b-toggle.rekeningNasabah>
                <p class="sub-sub-title">Rekening Tabungan <span class="arrow-down pull-right" /></p>
            </div>
            <b-collapse id="rekeningNasabah">
                <div>
                    <div class="form-group">
                        <label>Nama bank</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].name }}</span>
                    </div>
                    <div class="form-group">
                        <label>No Rekening</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].account_no }}</span>
                    </div>
                    <div class="form-group">
                        <label>Cabang</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].branch }}</span>
                    </div>
                    <div class="form-group">
                        <label>Telepon</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].phonenumber }}</span>
                    </div>
                    <div class="form-group">
                        <label>Jenis Rekening</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].type_account }}</span>
                    </div>
                </div>
            </b-collapse>
            <div v-b-toggle.kontakDarurat>
                <p class="sub-sub-title">Kontak darurat <span class="arrow-down pull-right" /></p>
            </div>
            <b-collapse id="kontakDarurat">
                <div class="form-group">
                    <label for="">Nama<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataEmergency.fullname }}</span>
                </div>
                <div class="form-group">
                    <label for="">Alamat<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataEmergency.address }}</span>
                </div>
                <div class="form-group">
                    <label>Kodepos<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataEmergency.postcode }}</span>
                </div>
                <div class="form-group">
                    <label>No Telepon<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataEmergency.phonenumber }}</span>
                </div>
                <div class="form-group">
                    <label for="">Hubungan anda<span> * </span></label>
                    <span>:</span>
                    <span>{{ dataEmergency.relationship }}</span>
                </div>
            </b-collapse>
            <div v-b-toggle.accountInfo v-if="dataTradeAcount.length > 0">
                <p class="sub-sub-title">Info Akun <span class="arrow-down pull-right" /></p>
            </div>
            <b-collapse id="accountInfo">
                <div v-for="(infoAcount, i) in dataTradeAcount" :key="i">
                    <div>
                        <p v-if="infoAcount.platform == 'BEI05001'">Jafets Now</p>
                        <p v-if="infoAcount.platform == 'BEI05002'">Meta Trader 5</p>
                    </div>
                    <div class="form-group">
                        <label for="">Username<span> * </span></label>
                        <span>:</span>
                        <span>{{ infoAcount.username }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Password<span> * </span></label>
                        <span>:</span>
                        <span>{{ infoAcount.password }}</span>
                    </div>
                </div>
            </b-collapse>
        </div>
        <div class="wrap-button mt-5 mb-3 mx-5 d-flex justify-content-end" v-if="dataPribadi.status == 2">
            <button type="button" class="btn btn-danger mr-3" @click="sendData('modalReject')" v-show="role != 13">
                Tolak
            </button>
            <button type="button" class="btn btn-primary" @click="sendData('acceptUser')" v-show="role != 13">
                Verified
            </button>
        </div>
        <b-modal ref="modalReject" hide-footer title="Tolak Nasabah Baru">
            <form @submit.prevent="reject">
                <div class="modal-body">
                    Apakah Anda yakin memasukan akun <b>{{ dataPribadi.fullname }}</b> ke dalam daftar Reject?
                    <textarea
                        name="input message"
                        cols="60"
                        rows="5"
                        placeholder="Berikan alasan atau kekurangan isian/berkas Nasabah "
                        v-model="$v.description.$model"
                        minlength="30"
                    ></textarea>
                    <div v-if="$v.description.$error">
                        <div class="error" v-if="!$v.description.required">
                            Alasan tidak boleh kosong
                        </div>
                        <div class="error" v-if="!$v.description.minLength">
                            Alasan minimal 30 karakter
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn-primer" aria-hidden="true">
                        <b-spinner small variant="ligth" v-if="isLoading" style="width: 20px; height: 20px"></b-spinner>
                        <span v-else>Setuju</span>
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal ref="acceptUser" title="Terima Nasabah Baru">
            <h5 class="text-center">
                Apakah Anda yakin data nasabah <b>{{ dataPribadi.fullname }}</b> sudah lengkap?
            </h5>
            <template #modal-footer>
                <button type="button" class="btn btn-scondary" @click="hideModal('acceptUser')">Cancel</button>
                <button type="button" class="btn btn-primer" @click="approveDocument">
                    <b-spinner variant="light" small v-if="isLoadingAcc"></b-spinner>
                    <span v-else>Submit</span>
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
// import moment from 'moment'

import html2canvas from "html2canvas";
import * as JsPDF from "jspdf";
import Simulasi from "../../assets/filedownload/Simulasi";
import Loading from "../../assets/Loading";
import BoFinance from "../../assets/filedownload/BoFinance.vue";
import Slider from "../../assets/Slider.vue";
import KodeAkses from "../../assets/filedownload/KodeAkses.vue";
import { required, minLength } from "vuelidate/lib/validators";
import ProfilPerusahaan from "../../assets/filedownload/ProfilPerusahaan.vue";
import DisclosureStatement from "../../assets/filedownload/DisclosureStatement.vue";
import Resiko from "../../assets/filedownload/Resiko.vue";
import Amanah from "../../assets/filedownload/Amanah.vue";
import TradingGofx from "../../assets/filedownload/TradingGofx.vue";
import TradingJfx from "../../assets/filedownload/TradingJfx.vue";
import ProfilUser from "../component/ProfilUser.vue";

import html2pdf from "html2pdf.js";

export default {
    components: {
        Simulasi,
        Loading,
        BoFinance,
        Slider,
        KodeAkses,
        ProfilPerusahaan,
        DisclosureStatement,
        Resiko,
        Amanah,
        TradingGofx,
        TradingJfx,
        ProfilUser,
    },
    data() {
        return {
            url: "https://api-kyc-abi-dev.abicommodity.co.id/v2/get/file",
            disputeValue: "",
            dataTradeAcount: [],
            dataEmergency: [],
            dataCustomer: [],
            dataFinance: [],
            dataWork: [],
            dataPribadi: [],
            dataAtachment: [],
            description: "",
            role: localStorage.getItem("role"),
            isLoadingAcc: false,
            print: {
                full_name: "",
                broker_name: "",
                alamat: "",
                phone_number: "",
                identity_owner: "",
                job: "",
                tempat_ttd: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
                has_set_trading_simulation: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                has_set_disclosure: "",
                tanggal_diterima: null,
                no_ac: "",
                statement: Boolean,
            },
            selectedDownload: "",
            slide: "",
            slideImage: "",
            counter: 1,
            allData: {
                dataEmergency: [],
                dataCustomer: [],
                dataFinance: [],
                dataWork: [],
                dataPribadi: [],
                tandaTangan: "",
                // data:'data'
            },
            isLoading: false,
            imgagePreview: "",
            textImage: "Foto Terkini",
            urlVideo: "",
            changevideo: 0,
            religion: "",
            identity: "",
            platform: "",
            phonenumber: "",
            dataImags: {
                ktp: "",
                photo: "",
                photo_ktp: "",
                signature: "",
                video_statement: "",
                kk: "",
                npwp: "",
            },
        };
    },
    validations: {
        description: {
            required,
            minLength: minLength(30),
        },
    },
    mounted() {
        // axios.get("/v2/user/profile").then((res) => {
        //   this.phonenumber = res.data.data.user.phonenumber;
        // });
        this.platform = localStorage.getItem("platform");
        const role = localStorage.getItem("role");
        let url;
        const id = this.$route.params.id;
        if (role == 13) {
            url = "/v1/nasabah/get/bank/" + id;
        } else {
            let urlAdmin;
            if (role == "0") {
                urlAdmin = "superadmin";
            } else {
                urlAdmin = "admin-broker";
            }
            url = "/v2/" + urlAdmin + "/kyc/detail/" + id;
        }
        axios.get(url).then((res) => {
            this.dataPribadi = res.data.data.customer;
            this.dataTradeAcount = res.data.data.tradeAccount;
            this.dataEmergency = res.data.data.emergencyContact;
            this.dataCustomer = res.data.data.customer.bank_account;
            this.dataFinance = res.data.data.financial;
            this.dataWork = res.data.data.employment;
            this.dataAtachment = res.data.data.attachment;
            this.$store.dispatch("getImageAccess", this.dataAtachment.ktp).then((res) => {
                this.dataImags.ktp = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.photo).then((res) => {
                this.dataImags.photo = res;
                this.imgagePreview = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.photo_with_ktp).then((res) => {
                this.dataImags.photo_ktp = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.signature).then((res) => {
                this.dataImags.signature = res;

                this.print.tandaTangan = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.statement_video).then((res) => {
                this.dataImags.video_statement = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.kk).then((res) => {
                this.dataImags.kk = res;
            });
            this.$store.dispatch("getImageAccess", this.dataAtachment.npwp).then((res) => {
                this.dataImags.npwp = res;
            });
            this.religion = this.dataPribadi.religion_type;

            this.print.has_set_company_profile = this.dataPribadi.has_set_company_profile;
            this.print.has_set_trading_simulation = this.dataPribadi.has_set_trading_simulation;
            this.print.statement = this.dataPribadi.has_set_trading_simulation;
            this.print.has_set_disclosure = this.dataPribadi.disclosure_customer;
            this.print.has_set_risk = this.dataPribadi.has_set_risk;
            this.print.has_set_mandate = this.dataPribadi.has_set_mandate;
            this.print.tanggal_diterima = this.dataPribadi.created_at;
            this.print.broker_name = this.dataPribadi.broker_agent;

            this.allData.dataPribadi = this.dataPribadi;
            this.allData.dataEmergency = this.dataEmergency;
            this.allData.dataCustomer = this.dataCustomer;
            this.allData.dataFinance = this.dataFinance;
            this.allData.dataWork = this.dataWork;
            let dataAddress = this.dataPribadi.identity_address;
            this.disputeValue = this.dataPribadi.problem_solving;
            this.print.fullname = this.dataPribadi.fullname;
            this.print.alamat =
                dataAddress.address +
                " Kec. " +
                dataAddress.village +
                " Kel. " +
                dataAddress.district +
                " " +
                dataAddress.regency +
                " " +
                dataAddress.province +
                " " +
                dataAddress.postcode;
            this.print.tempat_ttd = dataAddress.regency;
            this.print.ktp = this.dataPribadi.ktp_no;
            this.print.pekerjaan = this.dataWork.occupation_type.name;

            this.print.tanggalLahir = this.dataPribadi.date_of_birth;
            this.print.tempat_lahir = this.dataPribadi.place_of_birth;

            this.print.noKantor = this.dataWork.company_address.telephone;
            this.print.jabatanNasabah = this.dataWork.other_position;
            this.print.platform = this.dataPribadi.platform;
        });
        this.slide = document.querySelector(".img-user");
    },
    computed: {
        dataKYC() {
            return this.$store.getters.dataKYC;
        },
    },
    methods: {
        approveDocument() {
            this.isLoadingAcc = true;
            axios
                .patch("/v2/admin-broker/kyc/approve-document/" + this.$route.params.id)
                .then((res) => {
                    let id_activity = res.data.data.activity_id;
                    if (res.data.data.status_code == "00") {
                        this.isLoadingAcc = false;
                        this.$toast.success("Nasabah berhasil diterima");
                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                })
                .then((error) => {
                    console.log(error.response);
                });
        },
        reject() {
            this.$v.description.$touch();
            if (this.$v.description.$error) {
                return;
            }
            this.isLoading = true;
            axios
                .put("/v2/admin-broker/kyc/reject/" + this.$route.params.id, {
                    description: this.description,
                })
                .then((res) => {
                    let id_activity = res.data.data.activity_id;

                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.isLoading = false;
                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });
                        this.$notify({
                            group: "foo",
                            title: "<h5> Nasabah Baru berhasil Ditolak </h5>",
                            type: "success",
                            duration: 2000,
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    } else if (status == 2011) {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5> Nasabah Baru tidak valid </h5>",
                            type: "error",
                            duration: 2000,
                        });
                    }
                });
        },
        sendData(refModal) {
            this.description = "";
            this.$refs[refModal].show();
        },
        hideModal(refModal) {
            this.$refs[refModal].hide();
        },
        getImg(img, text) {
            this.imgagePreview = img;
            this.textImage = text;
            this.changevideo = 0;
            // console.log(text)
        },
        videoURL(text) {
            // this.urlVideo = url
            this.changevideo = 1;
            this.textImage = text;
        },
        downloadViaWindow() {
            this.isLoading = true;
            let opt = {
                margin: 10,
                filename: this.dataPribadi.fullname + "_pbk.pdf",
                pagebreak: { mode: ["css", "legacy"] },
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
            };
            let element = document.getElementById("printCimb");
            // html2pdf(document.getElementById("printCimb"), opt);
            // this.isLoading = false;
            html2pdf()
                .set(opt)
                .from(element)
                .save()
                .then(() => {
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        downloadSimulasi() {
            this.isLoading = true;
            var data;
            var name = "";
            if (this.selectedDownload == 1) {
                name = "amanah.pdf";
                data = document.getElementById("printPernyataan");
            } else if (this.selectedDownload == 2) {
                name = "simulasi.pdf";
                data = document.getElementById("printSimulasi");
            } else {
                name = this.dataPribadi.fullname + "_pbk.pdf";
                data = document.getElementById("printCimb");
            }
            // var canvasElement = document.createElement("canvas");

            html2canvas(data, { useCORS: true, scale: 2, allowTaint: true, scrollY: 0 }).then((canvas) => {
                const image = { type: "jpeg", quality: 0.98 };
                const margin = [10, 10];
                var imgWidth = 210;
                var pageHeight = 297;

                var innerPageWidth = imgWidth - margin[0] * 2;
                var innerPageHeight = pageHeight - margin[1] * 2;

                var pxFullHeight = canvas.height;
                var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
                var nPages = Math.ceil(pxFullHeight / pxPageHeight);

                pageHeight = innerPageHeight;

                var pageCanvas = document.createElement("canvas");
                var pageCtx = pageCanvas.getContext("2d");
                pageCanvas.width = canvas.width;
                pageCanvas.height = pxPageHeight;

                var pdf = new JsPDF("p", "mm", "a4");
                for (var page = 0; page < nPages; page++) {
                    if (page === nPages && pxFullHeight % pxPageHeight !== 0) {
                        pageCanvas.height = pxFullHeight % pxPageHeight;
                        pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
                    }

                    var w = pageCanvas.width;
                    var h = pageCanvas.height;
                    pageCtx.fillStyle = "white";
                    pageCtx.fillRect(0, 0, w, h);
                    pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                    if (page >= 0) pdf.addPage();
                    debugger;
                    var imgData = pageCanvas.toDataURL("image/png");
                    pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
                }

                this.tradingRuleGofx = false;
                pdf.save(name);
                this.isLoading = false;
            });
        },
        downloadFile() {
            const pdf = new JsPDF("p", "pt", "A4");
            let margin = {
                top: 40,
                bottom: 40,
                left: 40,
                width: 40,
            };
            // let ref = this.$refs.docPdf;
            // console.log(ref);
            pdf.fromHTML(this.$refs.docPdf, margin.left, margin.top, {
                width: margin.width,
            });
            pdf.save("testPDF.pdf");
        },
        prevSlide() {
            this.slideImage = this.slide.children[0].clientWidth;

            // if(this.counter < this.slide.children.length){
            this.counter--;
            // console.log(-this.slideImage * this.counter)
            this.slide.style.transform = "translateX(" + -this.slideImage * this.counter + "px)";

            // }
        },
        nextSlide() {
            // console.log(this.slide.nextElementSibling)
            this.slideImage = this.slide.children[0].clientWidth;
            if (this.counter < this.slide.children.length) {
                this.slide.style.transform = "translateX(" + -this.slideImage * this.counter + "px)";
                this.counter++;
            }
        },
    },
};
</script>

<style scoped>
.img {
    position: relative;
}

.img-preview img {
    width: 314px;
    height: 220px;
    object-fit: scale-down;
}

.img-preview video {
    width: 390px;
    height: 220px;
}

.text-img {
    background-image: linear-gradient(to top, rgba(70, 0, 0, 0.3), rgba(255, 0, 0, 0));
    position: absolute;
    width: 100%;
    bottom: 0px;
    height: 45px;
    color: white;
    line-height: 3;
}

.wrap-img-mini {
    display: flex;
    margin: 15px;
}

.img-mini {
    width: 72px;
    height: 59px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 2px 0 rgba(74, 143, 174, 0.91);
}

.img-mini img {
    cursor: pointer;
    object-fit: contain;
    height: 57px;
    border-radius: 5px;
}

.img-mini:last-child {
    margin-right: 0;
}

.background-video {
    background: black;
    width: 100%;
    height: 37px;
    position: relative;
    cursor: pointer;
}

.background-video::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 12px solid white;
    position: absolute;
    left: 50%;
    top: 50%;
    opacity: 0.7;
    transform: translate(-38%, -50%);
}

.wrap-download {
    border: solid 1px #dddddd;
    padding: 5px 20px;
    border-radius: 10px;
    background-color: var(--primary);
    color: white;
    cursor: pointer;
}

.wrap-title {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    margin-bottom: 2rem;
}

.download {
    border: solid 1px #dddddd;
    height: 37px;
    width: 132px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.7;
    margin-right: 25px;
}

.download:hover {
    background: var(--primary);
    color: #ffffff;
}

.text-download {
    cursor: pointer;
    /* font-size: 12px; */
}

.text-download:hover {
    color: var(--primary);
}

.arrow-down {
    border: solid var(--primary);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
}

.wrap-personal-data {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    flex-wrap: wrap;
}

.form-group {
    display: flex;
    gap: 0.6rem;
    align-items: baseline;
}

.form-group span {
    font-size: 14px;
}

.sub {
    font-weight: bold;
    margin: 20px 0;
    font-size: 15px;
}

.content-review {
    border-radius: 15px;
    border: solid 1px rgba(112, 112, 112, 0.25);
    margin-bottom: 50px;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

input[type="file"] {
    border: none;
}

.input-file {
    /* visibility: hidden; */
    /* display: none; */
    opacity: 0;
    cursor: pointer;
    vertical-align: middle;
    /* border: solid 1px #c43e00; */
}

.label-upload {
    position: absolute;
    left: 247px;
    width: 73%;
    height: 50px;
    border-radius: 10px;
    padding: 15px 20px;
    border: solid 1px #707070;
    color: rgba(112, 112, 112, 0.5);
    z-index: -1;
    background-color: none;
}

.input-file ~ .label-upload:focus {
    color: #707070;
    background-color: #fff;
    border-color: var(--primary) !important;
    outline: 0;
    z-index: 3;
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.label-upload::after {
    content: attr(data-browse);
    position: absolute;
    right: 0px;
    top: 0px;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    padding: 13px 30px;
    background: var(--primary);
    height: 22px;
    width: 90px;
    text-align: center;
    color: white;
    border-left: inherit;
    font-size: 14px;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

label {
    font-size: 14px;
    display: inline-block;
    margin: 0;
    font-weight: bold;
    width: 175px;
}

label span {
    color: #e74c3c;
}

.container-detail-input {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    width: 90%;
    margin: 0 auto;
}

.container-detail-input .form-group {
    margin-bottom: 0.5rem;
}

.container-detail-input .form-group label {
    width: 135px;
    font-weight: normal;
}
.container-detail-input .form-group .detail-alamat {
    width: 105px;
}

.container-detail-input .data-pekerjaan-print {
    flex: 1;
}

.container-detail-input .data-pribadi-print {
    flex: 1;
}

.data-pribadi .form-group label {
    flex: 1;
}

.data-pribadi .form-group span:last-child {
    flex: 2;
}

.detail-alamat {
    width: 145px;
    margin: 0 0 0 30px;
}
.data-pribadi .detail-alamat {
    flex: 0.82 !important;
}

.form-input {
    width: 73%;
    height: 50px;
    border-radius: 10px;
    border: solid 1px #707070;
}

.placholder {
    position: absolute;
    left: 270px;
    top: 15px;
    font-size: 14px;
    color: rgba(112, 112, 112, 0.5);
}

.data-pribadi {
    width: 57%;
}

.placholder::after {
    content: "upload file";
}

select {
    width: 73%;
    height: 50px;
    border-radius: 10px;
    border: solid 1px #707070;
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 25%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.pos-telepon {
    width: 25%;
}

.jabatan {
    height: 35px;
    width: 10%;
}

.tahun {
    margin: 0 20px 0 10px;
}

.identitas {
    width: 20%;
    margin: 0 32px 0 0;
    background-position-x: 88%;
}

.no-identitas {
    width: 50%;
}

.input-button {
    width: 50px;
    height: 50px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 6px;
    left: -1px;
    border: solid 1px #707070;
    background-color: var(--primary);
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    border-radius: 15px;
    border: solid 1px rgba(112, 112, 112, 0.25);
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    /* padding: 20px 30px; */
}

.nav-root {
    display: flex;
    /* justify-content: space-around; */
    margin: 0 0 50px;
    /* align-items: center; */
    position: relative;
}

.nav-root li {
    list-style: none;
    height: 65px;
    width: 200px;
    text-align: center;
    padding: 15px;
    line-height: 2;
    color: rgba(112, 112, 112, 0.5);
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid var(--primary);
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

.sub-sub-title {
    font-size: 18px;
    font-weight: bold;
    /* margin: 30px 0 30px; */
    cursor: pointer;
}

.img {
    float: right;
    text-align: center;
    width: 390px;
    height: 220px;
    object-fit: contain;
    box-shadow: 0 3px 6px 0 rgba(74, 143, 174, 0.91);
    margin-bottom: 55px;
}

.carousel-item img {
    height: 220px;
    object-fit: contain;
}

.img-user-content {
    display: inline-block;
}

.arrow-prev {
    cursor: pointer;
}

.arrow-next {
    cursor: pointer;
}

@media (max-width: 1024px) {
    .wrap-personal-data {
        flex-direction: unset;
    }
    .data-pribadi {
        margin-top: 100px;
        width: 100%;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .wrap-personal-data {
        flex-direction: unset;
    }
    .data-pribadi {
        margin-top: 70px;
        width: 100%;
    }
}
</style>
